import jsBridge from './utils/bridge.mjs';
import { API_LOG_AF_EVENT, API_LOG_GA_EVENT } from './utils/constant.mjs';
/**
 * af 埋点
 * @returns
 */
export function logAFEvent(params) {
    if (!params.params) {
        params.params = {};
    }
    return jsBridge.callPromise({
        minVersion: '1.0.1',
        noResponse: true
    }, API_LOG_AF_EVENT, params);
}
/**
 * ga 埋点
 * @returns
 */
export function logGAEvent(params) {
    if (!params.params) {
        params.params = {};
    }
    return jsBridge.callPromise({
        minVersion: '1.1.3',
        noResponse: true
    }, API_LOG_GA_EVENT, params);
}
